import styled from '@emotion/styled';
import { alpha, Stack } from '@mui/material';
import { FC } from 'react';

import PriceTagIcon from '@/assets/svg/ui-elements/price-tag.svg';
import { Chip, Tooltip, Typography } from '@/design-system';
import { theme } from '@/shared/design-system';

import { getTagIcon } from '../tag-icons';

const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  overflow: 'hidden',
});

const TagsBadge = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '2px 6px',
  borderRadius: 8,
  border: `1px solid ${alpha(theme.colors.white[100], 0.15)}`,
  flexShrink: 0,
  whiteSpace: 'nowrap',
});

interface UserTabNameCellProps {
  name: string;
  tags: string[];
}

export const UserTabNameCell: FC<UserTabNameCellProps> = ({ name, tags }) => (
  <Container>
    <Tooltip title={name.length > 18 ? name : undefined} disabled={name.length <= 18}>
      <Typography variant="body3" fontWeight={500} as="label" noWrap>
        {name}
      </Typography>
    </Tooltip>
    {tags.length > 0 && (
      <Tooltip
        title={
          <Stack direction="row" flexWrap="wrap" gap="6px">
            {tags.map((tag) => {
              const TagIcon = getTagIcon(tag);
              return <Chip key={tag} label={tag} size="sm" startIcon={<TagIcon />} />;
            })}
          </Stack>
        }
      >
        <TagsBadge>
          <PriceTagIcon />
          <Typography variant="body4" fontWeight={500}>
            {tags.length}
          </Typography>
        </TagsBadge>
      </Tooltip>
    )}
  </Container>
);
